import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class alvikbatterycharge extends ASTBlock {
    constructor(color) {
        super(color, "alvik_batterycharge")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "Batterieladung %1",
            "args0": [{
                "type": "input_dummy",
                "name": "NAME"
            }],
            "output": "Number"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}